export function currentAdmin() {
  try {
    return JSON.parse(localStorage.getItem('userData')) || {}
  } catch {
    return {}
  }
}
export const isSuperAdmin = () => currentAdmin().role === 'super_admin'
export const isStaff = () => ['super_admin', 'operator'].includes(currentAdmin().role)
export const isAgency = () => ['agency_admin', 'agency_staff'].includes(currentAdmin().role)
export const adminErrorMessage = (error) => error?.response?.data?.error?.msg ||
  error?.message ||
  '요청을 처리하지 못했습니다. 다시 시도해 주세요.'
export function filterAdminNavigation(items, role) {
  if (role === 'super_admin') return items
  if (role === 'operator') return items.map(item => ({...item, children:item.children?.filter(child => !['manageAdministrators', 'excelBackup', 'enrollmentForms'].includes(child.id))})).filter(item => item.id === 'operationsDashboard' || item.children?.length)
  return items
    .map((item) => ({
      ...item,
      children: item.children?.filter((child) => (process.env.REACT_APP_MERCHANT_ENABLED === 'true' ? ['manageCampaign'] : ['manageCampaign', 'excelBackup']).includes(child.id)),
    }))
    .filter((item) => item.id === 'operationsDashboard' || item.children?.length)
}
